import type { Locale } from "@engine/generate/conceptCopy.js";

export const DEFAULT_CHARACTER_ID = "guest" as const;

/** M.3+ will add real GameMaster policy objects; for now a single `default` id. */
export const DEFAULT_GM_ID = "default" as const;

/**
 * Per-learner preferences (M.2); extends to `Character` with Elo + mastery once we
 * collapse multiple `localStorage` keys (M.3+).
 */
export type CharacterPreferences = {
  locale: Locale;
  /** Policy id; `default` until GameMaster (M.3) ships. */
  gmId: string;
  subjectId: string;
};
